import {
    createLoadingSpinner,
    LOADING_SPINNER_SIZE_MEDIUM,
    LoadingSpinner,
} from '@vfde-brix/ws10/loading-spinner';
import {
    createComponentById,
    NO_PATTERN_BUSINESS_LOGIC,
} from '@vfde-brix/ws10/core';
import { HtmlId } from '../enums/elementId';

/**
 * Creates a WS10 Loading Spinner component.
 *
 * @param id ID of the button element.
 * @param isNested Option to place the loading spinner as a nested
 * child element inside a block/parent container (default=false).
 * @returns WS10 Loading Spinner component or null
 * if the element with the given ID is not found.
 */
export const mountLoadingSpinner = (id: HtmlId, isNested = false) =>
    createComponentById(createLoadingSpinner, id, {
        optNested: isNested,
        optSize: LOADING_SPINNER_SIZE_MEDIUM,
        business: NO_PATTERN_BUSINESS_LOGIC,
    });

/**
 * Sets the visibility of the given Loading Spinner component.
 *
 * @param spinner WS10 Loading Spinner component to show or hide, or null
 * @param isVisible Show/hide the component.
 */
export const setLoadingSpinnerVisibility = (spinner: LoadingSpinner | null, isVisible: boolean) => {
    if (!spinner) {
        return;
    }

    spinner.toggle(isVisible);
    spinner.toggleContainer(!isVisible);
};
